// auth.js
export const LOGOUT = 'LOGOUT'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE'
export const UPDATE_USER = 'UPDATE_USER'

// childnav.js
export const SHOW_CHILDNAV = 'SHOW_CHILDNAV'
export const HIDE_CHILDNAV = 'HIDE_CHILDNAV'

// buildings.js
export const SET_BUILDINGS = 'SET_BUILDINGS'
export const SET_BUILDING_DETAIL = 'SET_BUILDING_DETAIL'

// folder.js
export const SET_FOLDER_DETAIL = 'SET_FOLDER_DETAIL'
export const SET_FOLDER_VIEW_DETAIL = 'SET_FOLDER_VIEW_DETAIL'
export const SET_FOLDER_VIEW_LARGE = 'SET_FOLDER_VIEW_LARGE'
export const SET_CURRENT_FOLDER = 'SET_CURRENT_FOLDER'

// users.js
export const SET_USERS = 'SET_USERS'
export const SET_USER_DETAIL = 'SET_USER_DETAIL'

// organisations.js
export const SET_ORGS = 'SET_ORGS'
export const SET_ORG_DETAIL = 'SET_ORG_DETAIL'



// WEBPACK FOOTER //
// ./resources/assets/js/store/mutation-types.js